export const GROUP_TAXONOMIES_LIST_REQUEST = "GROUP_TAXONOMIES_LIST_REQUEST";
export const GROUP_TAXONOMIES_LIST_RECEIVE = "GROUP_TAXONOMIES_LIST_RECEIVE";
export const GROUP_TAXONOMIES_LIST_FAILURE = "GROUP_TAXONOMIES_LIST_FAILURE";
export const RESET_GROUP_TAXONOMIES_LIST = "RESET_GROUP_TAXONOMIES_LIST";
